import React, { useState } from "react";
import { Button, Input, Form, Typography, message } from "antd";
import { MailOutlined, LockOutlined, EyeOutlined } from "@ant-design/icons";
import { Helmet } from "react-helmet-async";
import "./login.css";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { trackEvent } from "../../utils/analytics";

const { Title } = Typography;
const Login = ({ email, setEmail, password, setPassword, onLogin }) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const handleSignUp = () => {
    trackEvent("click", "auth", "sign_up_link");
    navigate(`/signup`);
  };
  const handleForgotPass = () => {
    trackEvent("click", "auth", "forgot_password_link");
    navigate(`/forgetpassword`);
  };

  const handleSubmit = async () => {
    trackEvent("click", "auth", "login_button");
    setLoading(true);
    try {
      await onLogin();
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Login - Optix360</title>
      </Helmet>
      <div className="container">
        <div className="screen-1">
        {/* Form */}
        <Title level={3} style={{ textAlign: "center", marginBottom: "1em" }}>
          Login
        </Title>
        <Form
          layout="vertical"
          onFinish={handleSubmit}
        >
          {/* Email */}
          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              { required: true, message: "Please enter your email address!" },
              { type: "email", message: "Enter a valid email address!" },
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="Username@gmail.com"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Item>

          {/* Password */}
          <Form.Item label="Password" name="password"
            rules={[{ required: true, message: "Please enter your password!" },
            { min: 8, message: "Password must be at least 8 characters long!" },

            ]}>
            <Input
              prefix={<LockOutlined />}
              type={passwordVisible ? "text" : "password"}
              placeholder="············"
              // maxLength={8}
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              suffix={
                <EyeOutlined
                  onClick={() => setPasswordVisible(!passwordVisible)}
                  style={{ cursor: "pointer" }}
                />
              }
            />
          </Form.Item>

          {/* Login Button */}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-btn"
              block
              loading={loading}
              disabled={loading}
            >
              Login
            </Button>
          </Form.Item>
        </Form>

        {/* Footer */}
        <div className="footer">
          <span onClick={handleSignUp}>
            <Link>Sign up</Link>
          </span>
          <span onClick={handleForgotPass}>
            <Link>Forgot Password?</Link>
          </span>
        </div>
      </div>
    </div>
  </>);
};

export default Login;